<template>
  <div class="footer">
    <moduleWrap
      :active="active"
      title="<span style='margin-right: 20px'>汇聚万福</span><span>智赢未来</span>"
      titCol="#fff"
      subCol="rgba(255,255,255,0.7)"
      bgImg="/img/bg05.png"
      subTitle="<span style='margin-right: 10px'>赋能环保水利</span><span>引领数智创新</span>"
    >
      <div class="w-btn small" @click="consultVisible = true">产品咨询</div>
    </moduleWrap>
    <div class="foot-menu">
      <div class="foot-menu-inner">
        <div class="menu-left">
          <div v-for="(menu,ind) in menuData" :key="ind">
            <div class="menu-title">{{menu.name}}</div>
            <ul>
              <li v-for="(item,i) in menu.children" @click.stop="jumpTo(item)" :key="i">{{item.name}}</li>
            </ul>
          </div>
        </div>
        <div class="line"></div>
        <div class="menu-right">
          <div class="menu-title">联系我们</div>
          <ul>
            <li>
              <img src="/img/icon_fax@2x.png" width="16" height="16" alt="">lxudong2@linewell.com
            </li>
            <li>
              <img src="/img/icon_phone@2x.png" width="16" height="16" alt="">0591-87721622
            </li>
            <li>
              <img src="/img/icon_address@2x.png" width="16" height="16" alt="">福州市闽侯县万福中心1号楼21层
            </li>
            <li>
              <img src="/img/icon_code@2x.png" width="106" height="106" alt="">
            </li>
          </ul>
        </div>
      </div>
      <div class="record">
        版权所有&#169福建万福信息技术有限公司
        <span class="line"></span>
        <span @click="linkTo('https://beian.miit.gov.cn/')" class="bei">
          闽 ICP 备 18017881 号 -1
        </span>
        <span class="line"></span>
        <span class="police" @click="linkTo('https://www.beian.gov.cn')"><img src="/img/gongan.png"/>闽公网安备 35012102500722号</span>
      </div>
    </div>
    <Transition enter-active-class="animate__animated animate__pulse" leave-active-class="animate__animated animate__fadeOut">
      <consulting v-if="consultVisible" :dialog="true" @close="consultVisible=false"></consulting>
    </Transition>
  </div>
</template>

<script>
import consulting from '@/components/consulting.vue'
import moduleWrap from '@/components/moduleWrap.vue'
import { jumpTo } from '@/util.js'
export default {
  components: {
    moduleWrap,
    consulting
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      consultVisible: false,
      menuData: [
        {
          name: '解决方案',
          children: [
            {
              name: '水环境',
              path: '/home?solutionActive=0',
            },
            {
              name: '水工程',
              path: '/home?solutionActive=1',
            },
            {
              name: '水资源',
              path: '/home?solutionActive=2',
            },
            {
              name: '企业环保',
              path: '/home?solutionActive=3',
            },
          ],
        },
        {
          name: '核心能力',
          children: [
            {
              name: 'VIMS视频智能管理系统',
              path: '/pro_zhwl/spzngl',
            },
            {
              name: 'UMIoT元物联平台',
              path: '/pro_zhwl/ywl',
            },
            {
              name: 'EAIGo视频智能分析系统',
              path: '/pro_zhwl/spznfx',
            },
          ],
        },
        {
          name: '硬件产品',
          children: [
            {
              name: 'EAI智算精灵',
              path: '/hardware/zsjl',
            },
            {
              name: '水利一杆通WF-JC100',
              path: '/hardware/slygt',
            },
            {
              name: '存算一体VGIS-N7100',
              path: '/hardware/csyt',
            },
            {
              name: '水务遥测终端WF-R100',
              path: '/hardware/swyczd',
            },
            {
              name: '多通道振弦采集仪',
              path: '/hardware/dtdzxcjy',
            },
          ],
        },
      ],
    }
  },
  methods: {
    jumpTo,
    linkTo(url){
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.foot-menu {
  width: 100%;
  padding-top: 80px;
  background: #111720;
  .foot-menu-inner {
    width: 1200px;
    margin: 0 auto;
    color: #ffffff;
    font-size: 14px;
    display: flex;
    padding-bottom: 54px;
    border-bottom: 1px solid #424851;
    .menu-left {
      width: 780px;
      display: flex;
      justify-content: space-between;
      li:hover{
        cursor: pointer;
        color: #0b68bf;
      }
    }
    .line {
      width: 1px;
      height: 150px;
      margin: 32px 170px 0 70px;
      background: #424851;
    }
    .menu-title {
      font-weight: bold;
      font-size: 20px;
      margin-bottom: 32px;
    }
    li {
      margin-bottom: 16px;
      img{
        vertical-align: middle;
        margin-right: 4px;
      }
    }
    .menu-right {
      width: 244px;
    }
  }
  .record{
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: rgba($color: #fff, $alpha: 0.7);
    .line{
      margin: 0 16px;
      width: 1px;
      height: 14px;
      display: inline-block;
      background: rgba($color: #fff, $alpha: 0.7);
    }
    .bei,.police{
      cursor: pointer;
      img{
        vertical-align: middle;
        margin-right: 10px;
      }
      &:hover{
        color: #0b68bf;
      }
    }
  }
}
</style>